import { Slide } from "react-reveal";
import FaqCard from "../reusables/FaqCard";
import FaqCardList from "../reusables/FaqCardList";
import OtherFAQs from "../reusables/OtherFAQs";

const SystemFaqsBody = () => {
  return (
    <section className="faqs section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <div className="section-head center width-600 margin-auto section-spacing-50 no-padding-top">
              <p className="section-tag boldTitle">FAQS</p>
              <Slide top>
                <h2 className="section-title ntuna-text-fill">
                  Frequently Asked Questions
                </h2>
              </Slide>
            </div>
            <div className="section-body">
              <ul className="faqs-container width-600 margin-auto">
                <FaqCard
                  faq="What is a custom business system?"
                  answer="A custom business system is software built specifically for your organization’s operations. Unlike off-the-shelf tools, it is designed around your workflows, processes, and goals—giving you better efficiency, control, and scalability."
                />

                <FaqCardList faq="How is a custom system different from using existing software?">
                  <p>
                    Existing software forces you to adapt your business to its
                    limitations. A custom system is built around your business,
                    allowing you to:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Automate your exact workflows</span>
                    </li>
                    <li>
                      <span>Integrate all your tools into one system</span>
                    </li>
                    <li>
                      <span>
                        Scale and upgrade without restrictions and limitations
                      </span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="What types of systems do you develop?">
                  <p>We build a wide range of systems including:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>CRM systems (customer management)</span>
                    </li>
                    <li>
                      <span>ERP systems (operations & resources)</span>
                    </li>
                    <li>
                      <span>Booking & reservation systems</span>
                    </li>
                    <li>
                      <span>Inventory & stock management systems</span>
                    </li>
                    <li>
                      <span>
                        Institutional Management and enterprise systems (School,
                        hospital, farm, etc)
                      </span>
                    </li>
                    <li>
                      <span>Internal dashboards and reporting tools</span>
                    </li>
                    <li>
                      <span>Industry specific systems</span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="Can you integrate our existing tools and software?">
                  <p>Yes. We integrate systems with:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Payment platforms (cards, mobile money, POS)</span>
                    </li>
                    <li>
                      <span>CRMs, ERPs, and accounting tools</span>
                    </li>
                    <li>
                      <span>Third-party APIs and external services</span>
                    </li>
                  </ul>
                  <p>This ensures all your systems work together seamlessly.</p>
                </FaqCardList>
                <FaqCardList faq="How long does it take to develop a system?">
                  <p>It depends on complexity.</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Simple systems: 2–4 weeks</span>
                    </li>
                    <li>
                      <span>Medium systems: 1–2 months</span>
                    </li>
                    <li>
                      <span>Advanced systems: 2–4+ months</span>
                    </li>
                  </ul>
                  <p>
                    We provide a clear timeline after understanding your
                    requirements.
                  </p>
                </FaqCardList>
                <FaqCardList faq="Will the system be scalable as our business grows?">
                  <p>
                    Yes. All our systems are built with scalable architecture,
                    meaning:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>You can add new features anytime</span>
                    </li>
                    <li>
                      <span>Handle more users and data</span>
                    </li>
                    <li>
                      <span>Expand without rebuilding from scratch</span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="Is the system secure?">
                  <p>Yes. We implement:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Secure authentication systems</span>
                    </li>
                    <li>
                      <span>Role-based access control</span>
                    </li>
                    <li>
                      <span>Data encryption</span>
                    </li>
                    <li>
                      <span>Activity logs and monitoring</span>
                    </li>
                  </ul>
                  <p>Security is built into the system from the ground up.</p>
                </FaqCardList>
                <FaqCardList faq="Can multiple users access the system?">
                  <p>Yes. Systems are built to support:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Multiple users</span>
                    </li>
                    <li>
                      <span>Different roles and permissions</span>
                    </li>
                    <li>
                      <span>
                        Controlled access to specific features and data
                      </span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="Will the system work on mobile devices?">
                  <p>
                    Yes. Depending on the use-cases and requirements of your
                    system, we can build it to be:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Mobile-responsive</span>
                    </li>
                    <li>
                      <span>Accessible on phones, tablets, and desktops</span>
                    </li>
                  </ul>
                  <p>We can also integrate with mobile apps if needed.</p>
                </FaqCardList>
                <FaqCardList faq="Do you provide training after development?">
                  <p>Yes. We train your team on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>How to use the system</span>
                    </li>
                    <li>
                      <span>Managing workflows</span>
                    </li>
                    <li>
                      <span>Handling daily operations</span>
                    </li>
                  </ul>
                  <p>
                    We also provide documentation and ongoing support if needed.
                  </p>
                </FaqCardList>
                <FaqCardList faq="What happens after the system is launched?">
                  <p>We provide:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Ongoing support</span>
                    </li>
                    <li>
                      <span>Maintenance and updates</span>
                    </li>
                    <li>
                      <span>Performance monitoring</span>
                    </li>
                    <li>
                      <span>Feature upgrades as your business grows</span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="Can you upgrade or replace our existing system?">
                  <p>Yes. We can:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Improve your current system</span>
                    </li>
                    <li>
                      <span>Migrate your data safely</span>
                    </li>
                    <li>
                      <span>Rebuild a better, more efficient version</span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="Do you use templates or pre-built systems?">
                  <p>
                    No. We build systems from scratch based on your requirements
                    to ensure:
                  </p>
                  <ul className="faq-ulist">
                    <li>
                      <span>Better performance</span>
                    </li>
                    <li>
                      <span>Full control</span>
                    </li>
                    <li>
                      <span>Flexibility and scalability</span>
                    </li>
                  </ul>
                </FaqCardList>
                <FaqCardList faq="How much does a custom system cost?">
                  <p>Costs depend on:</p>
                  <ul className="faq-ulist">
                    <li>
                      <span>System complexity</span>
                    </li>
                    <li>
                      <span>Features required</span>
                    </li>
                    <li>
                      <span>Integrations needed</span>
                    </li>
                  </ul>
                  <p>
                    We provide a custom quote after understanding your needs.
                  </p>
                </FaqCardList>
                <FaqCardList faq="How do I/we get started?">
                  <p>
                    Simply{" "}
                    <a
                      href="/contacts"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      contact us
                    </a>{" "}
                    or book a{" "}
                    <a href="/#" target="_blank" rel="noopener noreferrer">
                      consultation
                    </a>
                    . We’ll:
                  </p>
                  <ul className="faq-olist">
                    <li>
                      <span>Understand your needs</span>
                    </li>
                    <li>
                      <span>Features required</span>
                    </li>
                    <li>
                      <span>Define system requirements</span>
                    </li>
                    <li>
                      <span>Propose a solution and timeline</span>
                    </li>
                    <li>
                      <span>Agree on fee so you can make initial deposit</span>
                    </li>
                    <li>
                      <span>Begin development</span>
                    </li>
                  </ul>
                </FaqCardList>

                <FaqCard
                  faq="Do you offer payment plans?"
                  answer="Yes. We offer flexible payment plans to make it easier for clients to invest in their system for the efficiency and growth of their business and institution."
                />
              </ul>
            </div>
            <OtherFAQs />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SystemFaqsBody;
